import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class VagasService {
  constructor(private http: HttpClient) {}

  getVagas(): Observable<any> {
    let url = environment.serverApi + "/VagaCandidatoParts/vagas/3000";

    return this.http.get(url);
  }
}
